<template>
  <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
  <Component :is="tag || 'div'" class="bk-highlight" v-html="markup" />
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  text: { type: String, required: true },
  regex: { type: null, required: false },
  positions: { type: Array, required: false },
  tag: { type: String, required: false }
});
const highlightPositions = (text, positions) => {
  let result = "";
  let inTag = false;
  for (let i = 0; i < text.length; i++) {
    if (positions.includes(i)) {
      if (!inTag) {
        result += "<em>";
        inTag = true;
      }
      result += text[i];
    } else {
      if (inTag) {
        result += "</em>";
        inTag = false;
      }
      result += text[i];
    }
  }
  if (inTag) {
    result += "</em>";
  }
  return result;
};
const markup = computed(() => {
  if (props.positions?.length) {
    return highlightPositions(props.text, props.positions);
  }
  if (!props.regex) {
    return props.text;
  }
  const firstMatch = props.text.match(props.regex);
  const index = firstMatch ? props.text.toLowerCase().indexOf(firstMatch[0].toLowerCase()) : -1;
  if (index === -1) {
    return props.text;
  }
  const before = props.text.substring(Math.max(0, index - 30), index);
  const highlighted = props.text.substring(index).replace(props.regex, (match) => {
    return `<em>${match}</em>`;
  });
  return before + highlighted;
});
</script>
